import Cookies from "js-cookie";
import {
  CFW_CLIENT_COUNTRY,
  CFW_FACEBOOKID,
  CFW_GOOGLEID,
  CFW_LINKEDINID,
  CFW_LOGINFO,
  CFW_POINTS,
  CFW_TWITTERID,
} from "@genericComponents/CFW.js";
import { GetStorage, SetStorage, Decrypt } from "@genericComponents/SFW.js";
let serverCookie = null;
export const GetServerCookie = (cookieParam) => {
  serverCookie = cookieParam;
};
export const User = {
  GetUserInfo: (val) => {
    let usr = Cookies.get(CFW_LOGINFO) ?? serverCookie;
    if (usr) {
      try {
        usr = JSON.parse(Decrypt(usr));
      } catch (e) {
        console.log("User", e.message);
        return null;
      }
      if (!usr) {
        return null;
      }
      return usr[val];
    }
    return null;
  },
  SelectedCountry: (countryVal = null) => {
    const selectedCountry = countryVal ?? Cookies.get(CFW_CLIENT_COUNTRY);
    if (selectedCountry) {
      return JSON.parse(Decrypt(selectedCountry));
    }
    return null;
  },
  IsLoggedIn: (roles = "") => {
    return Cookies.get(CFW_LOGINFO) || serverCookie || (roles ?? "")
      ? true
      : false;
  },
  IsAdmin: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 16,
      ).length > 0
    );
  },
  IsSuperAdmin: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 15,
      ).length > 0
    );
  },
  IsCompanyOwner: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 17,
      ).length > 0
    );
  },
  IsAgency: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 18,
      ).length > 0
    );
  },
  IsTeamLeader: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 20,
      ).length > 0
    );
  },
  IsNormalUser: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 19,
      ).length > 0
    );
  },
  IsTranslator: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 21,
      ).length > 0
    );
  },
  IsDriver: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 39,
      ).length > 0
    );
  },
  IsOperatorOrMarketer: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 40,
      ).length > 0
    );
  },
  IsReseller: (roles = "") => {
    return (
      [...(User.GetUserInfo("Roles") || (roles ?? "")).split(",")].filter(
        (i) => parseInt(i, 10) === 41,
      ).length > 0
    );
  },
  Roles: () => {
    return User.GetUserInfo("Roles");
  },
  Email: () => {
    return User.GetUserInfo("Email") || "";
  },
  ContactNumber: () => {
    return User.GetUserInfo("ContactNumber") || "";
  },
  AccessToken: () => {
    const CFW_ACCESSTOKEN = "AccessToken";
    const accessToken =
      User.GetUserInfo(CFW_ACCESSTOKEN) || GetStorage(CFW_ACCESSTOKEN);
    if (accessToken) {
      SetStorage(CFW_ACCESSTOKEN, accessToken);
    }
    return accessToken || "";
  },
  FullName: () => {
    return User.GetUserInfo("FullName") || "";
  },
  PublisherId: () => {
    return User.GetUserInfo("PublisherId") || "";
  },
  Points: () => {
    return parseInt(User.GetUserInfo(CFW_POINTS) || "0", 10);
  },
  UserGUID: () => {
    return User.GetUserInfo("UserGUID") || "";
  },
  CountryId: () => {
    return User.GetUserInfo("CountryId") || "";
  },
  FacebookId: () => {
    return User.GetUserInfo(CFW_FACEBOOKID) ?? GetStorage(CFW_FACEBOOKID);
  },
  LinkedInId: () => {
    return User.GetUserInfo(CFW_LINKEDINID) ?? GetStorage(CFW_LINKEDINID);
  },
  GoogleId: () => {
    return User.GetUserInfo(CFW_GOOGLEID) ?? GetStorage(CFW_GOOGLEID);
  },
  TwitterId: () => {
    return User.GetUserInfo(CFW_TWITTERID) ?? GetStorage(CFW_TWITTERID);
  },
  ParentPublisherId: () => {
    return User.GetUserInfo("ParentPublisherId") || "";
  },
};
